<template>
    <div
      class="thumb"
      :class="onActive"
      @click="changeThumbnail"
      :style="{
        backgroundImage: `url( ${thumbnail})`,
        cursor: 'pointer'
      }"
    ></div>
</template>

<script>
export default {
  name: 'ThumbnailSection',
  props: {
    thumbnail: {
      type: String,
      default: '',
    },
    mainImg: {
      type: String,
      default: '',
    },
  },
  computed: {
    onActive() {
      if (this.mainImg === this.thumbnail) {
        return 'active';
      }
      return '';
    },
  },
  methods: {
    changeThumbnail() {
      this.active = 'active';
      this.$emit('change-main-img', this.thumbnail);
    },
  },
};
</script>

<style></style>
